<template>
  <q-btn-dropdown
    v-if="menuOptions.length > 1"
    no-caps
    size="xs"
    unelevated
    outline
    class="re-sm re-main q-px-md"
    style="border: red"
  >
    <q-list
      dense
      class="q-py-sm"
    >
      <q-item
        v-for="m in menuOptions"
        :key="m"
        v-close-popup
        clickable
        :to="pathTo(m)"
      >
        <q-item-section
          avatar
          class="avatar"
        >
          <q-avatar
            round
            size="sm"
          >
            <re-icon :name="m === enums.modules.OVM ? 'ic-dvm' : `ic-${m}`" />
          </q-avatar>
        </q-item-section>
        <q-item-section>
          <q-item-label class="text-secondary text-bold">
            {{
              m === enums.modules.DVM || m === enums.modules.OVM
                ? $t(`value.short.valuation`)
                : $t(`value.short.${m}`)
            }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </q-btn-dropdown>
  <re-button
    v-else-if="menuOptions.length === 1"
    :to="pathTo(submitableModules[0])"
    :label="$attrs.label ?? $t(`value.short.${submitableModules[0]}`)"
    :size="size"
    icon="mdi-plus"
    color="main"
    v-bind="$attrs"
  >
    <slot />
  </re-button>
</template>

<script setup>
import { computed, defineProps } from 'vue'

import { useCurUser } from '@/composables/useCurUser'
import { useDashboardRequestList } from '@/composables/useDashboardRequestList'
import enums from '@/plugins/enums'

const { submitableModules } = useCurUser()
const requests = useDashboardRequestList()
const props = defineProps({
  avoidModules: { type: Array, default: () => [] },
  collapseToProject: { type: Boolean, default: false },
  size: { type: String, default: 'md' },
})

const menuOptions = computed(() => {
  const modules = new Set(submitableModules.value)

  // If both OVM and DVM are present, prefer DVM
  if (modules.has(enums.modules.OVM) && modules.has(enums.modules.DVM)) {
    modules.delete(enums.modules.OVM)
  }
  // Remove avoided modules
  props.avoidModules.forEach((m) => modules.delete(m))

  // If CAT is present, collaps to project
  if (props.collapseToProject && modules.has(enums.modules.CAT)) {
    return [enums.modules.CAT]
  } else {
    return [...modules]
  }
})

const pathTo = (m) => {
  if (m === enums.modules.ERS) {
    return {
      name: 'ers.request',
      // NOTE: we could abstain from setting query.resetCurRequest here and rely on route.meta
      query: { resetCurRequest: true },
    }
  } else if (m === enums.modules.OEPC) {
    return {
      name: 'oepc.request',
      params: { action: 'welcome' },
      query: { resetCurRequest: true },
    }
  } else if (m === enums.modules.CAT) {
    if (requests.data.value.length) {
      return {
        name: 'dashboard',
      }
    }

    return {
      name: 'catalog-start',
    }
  } else {
    return {
      name: 'valuation.request',
      // TODO: split routes by action and move query.resetCurRequest to route.meta
      query: { valuation_type: m, resetCurRequest: true },
      params: { action: 'start' },
    }
  }
}
</script>
<style scoped lang="scss">
.avatar {
  min-width: auto;
}

// TODO: make a dropdown version of ReButton and use it here
.q-btn-dropdown {
  height: 2.858em;
  min-height: 2.858em;
  line-height: 1em;

  :deep(.q-icon) {
    height: 0.5em;
  }

  &.re-main {
    background-color: var(--q-accent) !important;
    // NOTE: we need to this to same as background to avoid problems with the border colour. Text is overriden with the next rule
    color: var(--q-accent) !important;
    :deep(.q-btn__content) {
      color: $base;
    }
  }
}
</style>
